module.exports = __webpack_public_path__ + "img/u3882.14ab0bbf.svg";